export function setBitmapVisible(canvas, visible) {
    canvas.style.display = visible ? 'block' : 'none';
    return canvas;
}
export const DEFAULT_BLUR_PX = 6;
export const DEFAULT_BLUR_TRANSITION = {
    durationMs: 60,
    easeIn: 'ease-in',
    easeOut: 'ease-out',
};
export const MASK_FADE_GRACE_MS = 120;
const fill = (bitmap, transition) => {
    bitmap.style.position = 'absolute';
    bitmap.style.inset = '0';
    bitmap.style.width = '100%';
    bitmap.style.height = '100%';
    bitmap.style.filter = '';
    bitmap.style.transition = `filter ${transition.durationMs}ms ${transition.easeIn}`;
};
const unfill = (bitmap) => {
    bitmap.style.position = '';
    bitmap.style.inset = '';
    bitmap.style.width = '';
    bitmap.style.height = '';
    bitmap.style.filter = '';
    bitmap.style.transition = '';
};
export function coverWithBitmap(mount, root, bitmap, transition = {}) {
    const blurTransition = {
        ...DEFAULT_BLUR_TRANSITION,
        ...transition,
    };
    const prevMountPosition = mount.style.position;
    if (getComputedStyle(mount).position === 'static') {
        mount.style.position = 'relative';
    }
    const prevRootVisibility = root.style.visibility;
    root.style.visibility = 'hidden';
    let shown = bitmap;
    let blurPx = 0;
    fill(shown, blurTransition);
    mount.appendChild(setBitmapVisible(shown, true));
    const hideCurrent = () => {
        setBitmapVisible(shown, false).remove();
        unfill(shown);
    };
    return {
        swapTo(next) {
            if (next === shown)
                return;
            hideCurrent();
            shown = next;
            blurPx = 0;
            fill(shown, blurTransition);
            mount.appendChild(setBitmapVisible(shown, true));
        },
        setBlur(px = DEFAULT_BLUR_PX) {
            const ease = px >= blurPx ? blurTransition.easeIn : blurTransition.easeOut;
            shown.style.transition = `filter ${blurTransition.durationMs}ms ${ease}`;
            shown.style.filter = px > 0 ? `blur(${px}px)` : '';
            blurPx = px;
        },
        release() {
            hideCurrent();
            root.style.visibility = prevRootVisibility;
            mount.style.position = prevMountPosition;
        },
        dismiss(fade) {
            const fading = shown;
            root.style.visibility = prevRootVisibility;
            let done = false;
            const finish = () => {
                if (done)
                    return;
                done = true;
                clearTimeout(timer);
                fading.removeEventListener('transitionend', onEnd);
                fading.style.opacity = '';
                setBitmapVisible(fading, false).remove();
                unfill(fading);
                mount.style.position = prevMountPosition;
            };
            const onEnd = (event) => {
                if (event.target === fading && event.propertyName === 'opacity')
                    finish();
            };
            fading.style.transition = `opacity ${fade.durationMs}ms ${fade.easing}`;
            fading.style.opacity = '0';
            fading.addEventListener('transitionend', onEnd);
            const timer = setTimeout(finish, fade.durationMs + MASK_FADE_GRACE_MS);
        },
    };
}
export function blurInPlace(root, transition = {}) {
    const blurTransition = {
        ...DEFAULT_BLUR_TRANSITION,
        ...transition,
    };
    const prevFilter = root.style.filter;
    const prevTransition = root.style.transition;
    const prevWillChange = root.style.willChange;
    let blurPx = 0;
    root.style.filter = '';
    root.style.transition = `filter ${blurTransition.durationMs}ms ${blurTransition.easeIn}`;
    root.style.willChange = 'filter';
    const releaseNow = () => {
        root.style.filter = prevFilter;
        root.style.transition = prevTransition;
        root.style.willChange = prevWillChange;
    };
    return {
        swapTo() {
        },
        setBlur(px = DEFAULT_BLUR_PX) {
            const ease = px >= blurPx ? blurTransition.easeIn : blurTransition.easeOut;
            root.style.transition = `filter ${blurTransition.durationMs}ms ${ease}`;
            root.style.filter = px > 0 ? `blur(${px}px)` : '';
            blurPx = px;
        },
        release: releaseNow,
        dismiss: releaseNow,
    };
}
//# sourceMappingURL=overlay.js.map